import React, { memo } from 'react';
import { useSelector } from 'react-redux';
import { Button } from 'react-bootstrap';
import { useHistory } from 'react-router-dom';

import { ordersSelector } from '../../../../redux/selectors/orders';

import { Flex } from '../../../../components/Layout';
import { FilterSearch } from '../../../../components/Filters';

const Search = () => {
  const { config } = useSelector((state) => ordersSelector(state));
  const history = useHistory();

  const onClickExport = (e) => {
    e.preventDefault();
    history.push('/orders/export');
  }

  return (
    <Flex
      align="baseline"
      gap={{ default: 4, lg: 8 }}
      width="100%"
    >
      {config?.access?.export_list
        ? (
          <Button
            onClick={onClickExport}
            bsStyle="link"
          >
            Export
          </Button>
        ) : null}
      <FilterSearch
        searchTypes={config?.search_types}
      />
    </Flex>
  )
}

export default memo(Search);
